type PrintElementOptions = {
  title?: string;
  size?: 'auto' | 'portrait' | 'landscape';
  mmMargin?: number;
};

export default function printElementById(
  elementId: string,
  options?: PrintElementOptions
): void {
  const elementToPrint = document.getElementById(elementId);
  if (!elementToPrint) {
    throw new Error(`Element with id '${elementId}' not found.`);
  }
  printElement(elementToPrint, options);
}

function printElement(
  elementToPrint: HTMLElement,
  options?: PrintElementOptions
) {
  const title = options?.title ?? 'Print';
  const size = options?.size ?? 'auto';
  const mmMargin = options?.mmMargin ?? 0;
  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.write(
      `<html><head><title>${title ?? 'Print'}</title>`
    );

    const printCSS = `
    <style>
        @media print {
            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            @page {
                size: ${size};
                margin: ${mmMargin}mm;
            }
        }
    </style>
    `;
    printWindow.document.write(printCSS);
    Array.from(document.styleSheets).forEach((styleSheet) => {
      try {
        if (styleSheet.cssRules) {
          // for internal style sheets
          const newStyleEl = printWindow.document.createElement('style');
          Array.from(styleSheet.cssRules).forEach((cssRule) => {
            newStyleEl.appendChild(
              printWindow.document.createTextNode(cssRule.cssText)
            );
          });
          printWindow.document.head.appendChild(newStyleEl);
        } else if (styleSheet.href) {
          // for external style sheets
          const newLinkEl = printWindow.document.createElement('link');
          newLinkEl.rel = 'stylesheet';
          newLinkEl.href = styleSheet.href;
          printWindow.document.head.appendChild(newLinkEl);
        }
      } catch (e) {
        console.error('Error copying CSS styles: ', e);
      }
    });

    printWindow.document.write('</head><body>');
    printWindow.document.write(elementToPrint.outerHTML);
    printWindow.document.write('</body></html>');

    printWindow.document.close(); // Necessary for some browsers
    printWindow.focus(); // Necessary for some browsers
    setTimeout(() => {
      // Allow time for styles to apply
      printWindow.print();
      printWindow.close();
    }, 250);
  }
}

export function printHTML(html: string, options?: PrintElementOptions) {
  const element = document.createElement('div');
  element.innerHTML = html;
  printElement(element, options);
}
